import moment from 'moment-timezone';

const FormattedDate = ({ timeFrom, timeTo, tzFrom, tzTo }) => {
  if (!timeFrom || !timeTo || !tzFrom || !tzTo) {
    return null;
  }

  const timeFromTz = moment(timeFrom).tz(tzFrom);
  const timeToTz = moment(timeTo).tz(tzTo);

  return (
    <>
      {`${timeFromTz.format('D MMM')} , ${timeFromTz.format('HH:mm')} \u2014 ${timeToTz.format(
        'HH:mm'
      )}`}
    </>
  );
};

export default FormattedDate;
